<template>
    <v-card class="ma-3 pa-5">
        <h4>Create New Growth Phase Item</h4>
        <v-form ref="form">
            <v-row class="px-3">
                <v-text-field
                    v-model="newGrowthPhaseItem.growth_index"
                    class="mr-3"
                    type="text"
                    label="Growth Index"
                    required
                    :rules="[v => !!v || 'Growth Index is required']"
                />
                <v-text-field
                    v-model.number="newGrowthPhaseItem.yearly_active_temperature_sum_minimum"
                    class="mr-3"
                    type="number"
                    label="ATS Minimum"
                />
                <v-text-field
                    v-model="newGrowthPhaseItem.name"
                    class="mr-3"
                    type="text"
                    label="Name (Default)"
                    required
                    :rules="[v => !!v || 'Name is required']"
                />
            </v-row>
        <v-row class="px-3">
            <v-text-field
                v-model="newGrowthPhaseItem.locale.la_name"
                class="mr-3"
                type="text"
                label="LA"
            />
            <v-text-field
                v-model="newGrowthPhaseItem.locale.et_name"
                class="mr-3"
                type="text"
                label="ET"
            />
            <v-text-field
                v-model="newGrowthPhaseItem.locale.en_name"
                class="mr-3"
                type="text"
                label="EN"
            />
            <v-text-field
                v-model="newGrowthPhaseItem.locale.fi_name"
                class="mr-3"
                type="text"
                label="FI"
            />
            <v-text-field
                v-model="newGrowthPhaseItem.locale.lt_name"
                class="mr-3"
                type="text"
                label="LT"
            />
        </v-row>
            <v-row class="px-3">
                <v-btn
                    class="ma-4"
                    @click="createNewItem"
                    small
                    color="primary"
                >
                    Create
                </v-btn>
            </v-row>
        </v-form>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'CreateGrowthPhaseItemCard',
    props: {
        growthPhaseId: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ...mapState('cultureGrowthPhase', ['newGrowthPhaseItem']),
    },
    methods: {
        ...mapActions('cultureGrowthPhase', ['createGrowthPhaseItem', 'fetchGrowthPhaseItems']),
        async createNewItem() {
            // Validate required fields (check for empty or whitespace-only strings)
            if (!this.newGrowthPhaseItem.growth_index || !this.newGrowthPhaseItem.growth_index.trim()) {
                return alert('Please fill Growth Index field!')
            }
            if (!this.newGrowthPhaseItem.name || !this.newGrowthPhaseItem.name.trim()) {
                return alert('Please fill Name field!')
            }

            this.newGrowthPhaseItem.growth_phase_id = this.growthPhaseId
            await this.createGrowthPhaseItem()

            // Reset form validation after successful creation
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation()
                }
            })
        },
    },
    watch: {
        growthPhaseId: {
            immediate: true,
            handler(newVal) {
                if (this.newGrowthPhaseItem) {
                    this.newGrowthPhaseItem.growth_phase_id = newVal
                }
            },
        },
    },
}
</script>

<style scoped>
</style>
